export const LOADING_FORM_PUBLIC_DATA = "LOADING_FORM_PUBLIC_DATA";
export const LOADING_FORM_PUBLIC_DATA_ERR = "LOADING_FORM_PUBLIC_DATA_ERR";
export const LOADED_FORM_PUBLIC_DATA = "LOADED_PUBLIC_FORM_DATA";

export const ADDING_RESPONSE = "ADDING_RESPONSE";
export const ADDING_RESPONSE_ERR = "ADDING_RESPONSE_ERR";
export const ADDED_RESPONSE = "ADDED_RESPONSE";